import { render, staticRenderFns } from "./ItemStoreSpecial.vue?vue&type=template&id=2d2f9022&"
import script from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"
export * from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/401/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2f9022')) {
      api.createRecord('2d2f9022', component.options)
    } else {
      api.reload('2d2f9022', component.options)
    }
    module.hot.accept("./ItemStoreSpecial.vue?vue&type=template&id=2d2f9022&", function () {
      api.rerender('2d2f9022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/ItemStoreSpecial.vue"
export default component.exports